function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuerDiePerfekteVerarbeitung = function SvgFuerDiePerfekteVerarbeitung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.1 88.02"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M44.01.25C19.88.25.25 19.88.25 44.01s19.63 43.76 43.76 43.76 43.76-19.63 43.76-43.76S68.14.25 44.01.25Zm0 85.07C21.23 85.32 2.7 66.79 2.7 44.01S21.23 2.7 44.01 2.7s41.31 18.53 41.31 41.31-18.53 41.31-41.31 41.31Z",
    style: {
      stroke: "currentColor",
      strokeMiterlimit: 10,
      fill: "currentColor",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.83 38.07 11.23 23.78 50.2-54.83",
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "currentColor",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgFuerDiePerfekteVerarbeitung;